<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import i18n from './locales/index'

import { mapState, mapActions } from 'vuex'
import qs from 'qs'

export default {
  name: 'app',
  computed: {
    ...mapState('oem', ['oem']),
  },
  methods: {
    ...mapActions('oem', ['find_one']),
    checkOem (route) {
      const query = location.search.substring(1);
      const search = qs.parse(query)
      const oemName = search && search.oem_name;
      if (oemName) {
        this.find_one(oemName)
      }
    },
    initCozeSDK() {
      new CozeWebSDK.WebChatClient({
        config: {
          bot_id: '7501008629516992564',
          clear_history: true,
        },
        componentProps: {
          title: '老板助手的助手',
        },
        auth: {
          type: 'token',
          token: 'pat_DIQh5iHfzvsmYE5ut4isV2MrH20nyfAQv0jHwuRjJdjo0pcAaGvsvk086SbIHMQf',
          onRefreshToken: function () {
            return 'pat_DIQh5iHfzvsmYE5ut4isV2MrH20nyfAQv0jHwuRjJdjo0pcAaGvsvk086SbIHMQf'
          }
        }
      });
    }
  },
  created () {
    this.checkOem()
    // Load Coze SDK script dynamically
    const script = document.createElement('script')
    script.src = 'https://lf-cdn.coze.cn/obj/unpkg/flow-platform/chat-app-sdk/1.2.0-beta.6/libs/cn/index.js'
    script.onload = () => {
      this.initCozeSDK()
    }
    document.head.appendChild(script)
  }
}
</script>

<style lang="less">
.size {
  width: 100%;
  height: 100%;
}
html,
body {
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
#app {
  .size;
}
</style>
